"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPreviewContent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _interweave = require("interweave");

var _atoms = require("../../../atoms");

var _molecules = require("../../../molecules");

var _helpers = require("../../../util/helpers");

var _NotificationIcon = require("../NotificationIcon");

require("./NotificationPreviewContent.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NotificationPreviewContent = function NotificationPreviewContent(_ref) {
  var _currentMoment$home_t, _notification$message;

  var notification = _ref.notification,
      currentMoment = _ref.currentMoment,
      showTooltip = _ref.showTooltip,
      handleTraceIDClick = _ref.handleTraceIDClick,
      momentAdded = _ref.momentAdded,
      onDownload = _ref.onDownload;

  var _useState = (0, _react.useState)(showTooltip),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltipPreview = _useState2[0],
      setShowTooltipPreview = _useState2[1];

  var avatarUrl = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=");
  var momentLink = "https://go.traceup.com/#/".concat(currentMoment === null || currentMoment === void 0 ? void 0 : (_currentMoment$home_t = currentMoment.home_team) === null || _currentMoment$home_t === void 0 ? void 0 : _currentMoment$home_t.name, "/games/").concat(currentMoment === null || currentMoment === void 0 ? void 0 : currentMoment.game_id, "/all/C").concat(currentMoment === null || currentMoment === void 0 ? void 0 : currentMoment.game_clip_id);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setShowTooltipPreview(false);
    }, 10000);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "NotificationPreviewContent",
    span: "10"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    span: "10"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_NotificationIcon.NotificationIcon, {
    group: notification.message.group,
    marginRight: 2,
    iconSize: 24
  }), (_notification$message = notification.message) === null || _notification$message === void 0 ? void 0 : _notification$message.users.map(function (user) {
    return /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
      key: user.user_id,
      size: 40,
      className: "moment-avatars",
      imageUrl: avatarUrl + user.user_id,
      initials: (0, _helpers.getInitials)(user.first_name, user.last_name),
      marginRight: "2",
      marginTop: "1",
      marginBottom: "1"
    });
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: /*#__PURE__*/_react.default.createElement(_interweave.Markup, {
      content: notification.message.text
    }),
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Body,
    marginTop: "2"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: notification.message.subtitle,
    color: _atoms.Color.Grey2,
    type: _atoms.Label.Type.Body,
    marginTop: "1",
    className: "preview-content-subtitle"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: (0, _moment.default)(notification.msg_date).fromNow(),
    color: _atoms.Color.Grey2,
    type: _atoms.Label.Type.Body,
    marginTop: "1"
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    justifyContent: "space-evenly",
    padding: "4 0"
  }, showTooltipPreview && /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "preview-content-tooltip"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: "Save this to your profile!",
    color: _atoms.Color.White1,
    type: _atoms.Label.Type.Body,
    bold: true
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "tooltip-arrow"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "buttons-row"
  }, /*#__PURE__*/_react.default.createElement(_molecules.ShareMenu, {
    moment: currentMoment,
    momentLink: momentLink,
    marginRight: "2",
    onDownload: onDownload
  }, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    height: 56,
    width: 56,
    borderColor: "trace-tint2-color",
    color: _atoms.Color.Trace,
    icon: _atoms.Icon.Type.Action,
    iconColor: _atoms.Color.Trace
  })), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    span: "6",
    trkAction: "Notifications Preview ".concat(!momentAdded ? "Add to Trace iD" : "View my Profile", " Pressed"),
    onClick: handleTraceIDClick,
    primary: !momentAdded,
    content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !momentAdded && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      color: _atoms.Color.TraceTint2,
      type: _atoms.Icon.Type.TraceIDEmpty
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: !momentAdded ? "Save" : "View",
      marginLeft: "2"
    }))
  })))));
};

exports.NotificationPreviewContent = NotificationPreviewContent;